import { Badge, Box, Flex, Heading, Text } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { useApi } from "hooks/useApi";
import { useCache } from "hooks/useCache";
import { useMemo, useState } from "react";
import { statusColors } from "typing";
import DashboardTable from "../DashboardTable";

type Table3RowType = {
  id: string;
  tax_payment_date: string;
  tax_payment_method: string;
  created_at: string;
  amount: string;
  payment_method: string;
  status: any;
};

export default function TaxPaymentTable() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { getTaxAssessments } = useApi();
  const [searchBarValue34, setSearchBarValue34] = useState("");
  const { data: taxAssessments, mutate } = useCache("getTaxAssessments", () =>
    getTaxAssessments(page, "", searchBarValue34, pageSize)
  );
  const handleSearch = (event: any) => {
    const value = event.target.value;
    setSearchBarValue34(value);
    mutate(getTaxAssessments(page, "", value, pageSize));
  };
  const handleClearSearch = (event: any) => {
    setSearchBarValue34("");
    mutate(getTaxAssessments(page, ""));
  };

  const handleJumpToPage = (pg: number) => {
    setPage(pg);
    mutate(getTaxAssessments(pg));
  };
  const handleSetNextPage = () => {
    if (
      taxAssessments?.length > 0 &&
      taxAssessments[0].num_of_pages >= page + 1
    ) {
      setPage((prev: any) => prev + 1);
      mutate(getTaxAssessments(page + 1));
    }
  };
  const handleSetPrevPage = () => {
    if (taxAssessments?.length > 0 && page > 0) {
      setPage((prev: any) => prev - 1);
      mutate(getTaxAssessments(page + 1));
    }
  };

  const table3Columns = useMemo(() => {
    const table3ColumnHelper = createColumnHelper<Table3RowType>();
    return [
      table3ColumnHelper.accessor("tax_payment_date", {
        cell: (info) => (
          <Box flex={1}>
            <Flex gap="8px" alignItems="center" px="12px" py="0px">
              <Text style={{ textTransform: "capitalize" }}>
                {info.getValue<string>()
                  ? info.getValue<string>()
                  : info.row.original.created_at}
              </Text>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px">
            <Heading as="h6">Date</Heading>
          </Flex>
        ),
        meta: { width: "100px" },
      }),
      table3ColumnHelper.accessor("amount", {
        cell: (info) => (
          <Box flex={1}>
            <Flex gap="8px" alignItems="center" px="12px" py="0px">
              <Text style={{ textTransform: "capitalize" }}>
                {info.getValue<string>()} FCFA
              </Text>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px">
            <Heading as="h6">Montant</Heading>
          </Flex>
        ),
        meta: { width: "100px" },
      }),
      table3ColumnHelper.accessor("payment_method", {
        cell: (info) => (
          <Box flex={1}>
            <Flex gap="8px" alignItems="center" px="12px" py="0px">
              <Text style={{ textTransform: "capitalize" }}>
                {info.getValue<string>()}
              </Text>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px">
            <Heading as="h6">Méthode</Heading>
          </Flex>
        ),
        meta: { width: "60px" },
      }),
      table3ColumnHelper.accessor("status", {
        cell: (info) => (
          <Box flex={1}>
            <Flex
              gap="8px"
              alignItems="center"
              px="12px"
              py="0px"
              flexWrap={"wrap"}
              justifyContent={"flex-end"}
            >
              <Badge
                py={1.5}
                px={2}
                colorScheme={statusColors[info.getValue<string>()]}
                fontSize={"12px"}
                rounded={10}
                width={"80px"}
                style={{
                  fontWeight: "lighter",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  textTransform: "capitalize",
                }}
              >
                {info.getValue<string>() === "paid" ? "Payé" : "pas à jour"}
              </Badge>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px" justifyContent={"flex-end"}>
            <Heading as="h6">Statut</Heading>
          </Flex>
        ),
        meta: { width: "120px" },
      }),
    ];
  }, []);

  return (
    <>
      
      <DashboardTable
        title="Historique des paiements"
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        handleJumpToPage={handleJumpToPage}
        handleSearch={handleSearch}
        handleSetNextPage={handleSetNextPage}
        handleSetPrevPage={handleSetPrevPage}
        handleClearSearch={handleClearSearch}
        tableColumns={table3Columns}
        tableData={taxAssessments}
        searchKey={searchBarValue34}
        setSearchKey={setSearchBarValue34}
      />
    </>
  );
}
